// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weavetype-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
}
html[data-coreui-theme=dark] .weavetype-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
}
.weavetype-table-container .table {
  border-color: var(--table-border-color) !important;
}
.weavetype-table-container .table,
.weavetype-table-container .table thead,
.weavetype-table-container .table tbody,
.weavetype-table-container .table tr,
.weavetype-table-container .table th,
.weavetype-table-container .table td {
  border-color: var(--table-border-color) !important;
}
.weavetype-table-container .table:hover,
.weavetype-table-container .table thead:hover,
.weavetype-table-container .table tbody:hover,
.weavetype-table-container .table tr:hover,
.weavetype-table-container .table th:hover,
.weavetype-table-container .table td:hover {
  border-color: var(--table-border-color) !important;
}
.weavetype-table-container .card {
  border-color: var(--table-border-color) !important;
  background-color: var(--table-bg-color);
}
.weavetype-table-container .card:hover {
  border-color: var(--table-border-color) !important;
}
.weavetype-table-container .card .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.weavetype-table-container .table {
  width: 100%;
  margin-bottom: 0;
  color: var(--table-text-color);
}
.weavetype-table-container .table .table-header-cell {
  border-color: var(--table-border-color) !important;
  font-weight: 600;
}
.weavetype-table-container .table .table-header-cell.sortable-header {
  cursor: pointer;
}
.weavetype-table-container .table .table-header-cell:hover {
  border-color: var(--table-border-color) !important;
}
.weavetype-table-container .table tbody tr {
  border-color: var(--table-border-color) !important;
}
.weavetype-table-container .table tbody tr:hover {
  border-color: var(--table-border-color) !important;
  background-color: inherit;
}
.weavetype-table-container .table tbody tr td {
  border-color: var(--table-border-color) !important;
}
.weavetype-table-container .table tbody tr td:hover {
  border-color: var(--table-border-color) !important;
}
.weavetype-table-container .table-hover tbody tr:hover {
  background-color: inherit !important;
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.weavetype-table-container .table-hover tbody tr:hover td {
  color: var(--table-text-color) !important;
}
.weavetype-table-container .table-hover tbody tr:hover th {
  color: var(--table-text-color) !important;
}
.weavetype-table-container .pagination {
  margin-bottom: 0;
}
html[data-coreui-theme=dark] .weavetype-table-container .pagination {
  --cui-pagination-bg: var(--table-bg-color);
  --cui-pagination-color: var(--table-text-color);
  --cui-pagination-active-bg: var(--cui-primary);
  --cui-pagination-active-color: var(--table-text-color);
  --cui-pagination-disabled-bg: var(--table-bg-color);
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-border-color: var(--table-border-color);
}
html[data-coreui-theme=dark] .weavetype-table-container .form-select {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--table-border-color);
}
html[data-coreui-theme=dark] .weavetype-table-container .form-select:focus {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
html[data-coreui-theme=dark] .weavetype-table-container .form-select option {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.weavetype-table-container .d-flex.justify-content-between.align-items-center.mt-3 {
  margin-top: 1rem;
}
.weavetype-table-container .cursor-pointer {
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.weavetype-table-container .cursor-pointer:hover {
  opacity: 0.8;
}
.weavetype-table-container .text-center {
  text-align: center;
  padding: 1.5rem;
  font-style: italic;
}
.weavetype-table-container .badge-success {
  background-color: var(--cui-success) !important;
  color: #fff;
}
.weavetype-table-container .badge-danger {
  background-color: var(--cui-danger) !important;
  color: #fff;
}
.weavetype-table-container .table.table-hover > tbody > tr:hover {
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.weavetype-table-container .table.table-hover > tbody > tr:hover td {
  color: var(--table-text-color) !important;
}
.weavetype-table-container .table.table-hover > tbody > tr:hover th {
  color: var(--table-text-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/WeaveTypeTable/WeaveTypeTable.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,sDAAA;EACA,kDAAA;AACF;AACE;EACE,oDAAA;EACA,yDAAA;EACA,+CAAA;AACJ;AAEE;EACE,kDAAA;AAAJ;AAGE;;;;;;EAME,kDAAA;AADJ;AAGI;;;;;;EACE,kDAAA;AAIN;AAAE;EACE,kDAAA;EACA,uCAAA;AAEJ;AAAI;EACE,kDAAA;AAEN;AACI;EACE,uCAAA;EACA,8BAAA;AACN;AAGE;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;AADJ;AAGI;EACE,kDAAA;EACA,gBAAA;AADN;AAGM;EACE,eAAA;AADR;AAIM;EACE,kDAAA;AAFR;AAMI;EACE,kDAAA;AAJN;AAMM;EACE,kDAAA;EACA,yBAAA;AAJR;AAOM;EACE,kDAAA;AALR;AAOQ;EACE,kDAAA;AALV;AAWE;EACE,oCAAA;EACA,kDAAA;EACA,yCAAA;AATJ;AAWI;EACE,yCAAA;AATN;AAYI;EACE,yCAAA;AAVN;AAcE;EACE,gBAAA;AAZJ;AAgBI;EACE,0CAAA;EACA,+CAAA;EACA,8CAAA;EACA,sDAAA;EACA,mDAAA;EACA,2DAAA;EACA,wDAAA;AAdN;AAiBI;EACE,uCAAA;EACA,8BAAA;EACA,uCAAA;AAfN;AAiBM;EACE,uCAAA;EACA,8BAAA;AAfR;AAkBM;EACE,uCAAA;EACA,8BAAA;AAhBR;AAqBE;EACE,gBAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AApBJ;AAsBI;EACE,YAAA;AApBN;AAwBE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,+CAAA;EACA,WAAA;AAvBJ;AA0BE;EACE,8CAAA;EACA,WAAA;AAxBJ;AA2BE;EACE,kDAAA;EACA,yCAAA;AAzBJ;AA2BI;EACE,yCAAA;AAzBN;AA4BI;EACE,yCAAA;AA1BN","sourcesContent":[".weavetype-table-container {\n  --table-bg-color: #fff;\n  --table-border-color: var(--cui-border-color, #d8dbe0);\n  --table-text-color: var(--cui-body-color, #4f5d73);\n\n  html[data-coreui-theme=\"dark\"] & {\n    --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n    --table-border-color: var(--cui-dark-border-subtle, #333);\n    --table-text-color: var(--cui-body-color, #fff);\n  }\n\n  .table {\n    border-color: var(--table-border-color) !important;\n  }\n\n  .table,\n  .table thead,\n  .table tbody,\n  .table tr,\n  .table th,\n  .table td {\n    border-color: var(--table-border-color) !important;\n    \n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n  }\n\n  .card {\n    border-color: var(--table-border-color) !important;\n    background-color: var(--table-bg-color);\n    \n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n    \n    .card-body {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n    }\n  }\n\n  .table {\n    width: 100%;\n    margin-bottom: 0;\n    color: var(--table-text-color);\n    \n    .table-header-cell {\n      border-color: var(--table-border-color) !important;\n      font-weight: 600;\n      \n      &.sortable-header {\n        cursor: pointer;\n      }\n      \n      &:hover {\n        border-color: var(--table-border-color) !important;\n      }\n    }\n    \n    tbody tr {\n      border-color: var(--table-border-color) !important;\n      \n      &:hover {\n        border-color: var(--table-border-color) !important;\n        background-color: inherit;\n      }\n      \n      td {\n        border-color: var(--table-border-color) !important;\n        \n        &:hover {\n          border-color: var(--table-border-color) !important;\n        }\n      }\n    }\n  }\n\n  .table-hover tbody tr:hover {\n    background-color: inherit !important;\n    border-color: var(--table-border-color) !important;\n    color: var(--table-text-color) !important;\n    \n    td {\n      color: var(--table-text-color) !important;\n    }\n    \n    th {\n      color: var(--table-text-color) !important;\n    }\n  }\n\n  .pagination {\n    margin-bottom: 0;\n  }\n\n  html[data-coreui-theme=\"dark\"] & {\n    .pagination {\n      --cui-pagination-bg: var(--table-bg-color);\n      --cui-pagination-color: var(--table-text-color);\n      --cui-pagination-active-bg: var(--cui-primary);\n      --cui-pagination-active-color: var(--table-text-color);\n      --cui-pagination-disabled-bg: var(--table-bg-color);\n      --cui-pagination-disabled-color: var(--cui-secondary-color);\n      --cui-pagination-border-color: var(--table-border-color);\n    }\n    \n    .form-select {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n      border-color: var(--table-border-color);\n      \n      &:focus {\n        background-color: var(--table-bg-color);\n        color: var(--table-text-color);\n      }\n      \n      option {\n        background-color: var(--table-bg-color);\n        color: var(--table-text-color);\n      }\n    }\n  }\n\n  .d-flex.justify-content-between.align-items-center.mt-3 {\n    margin-top: 1rem;\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    \n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  .text-center {\n    text-align: center;\n    padding: 1.5rem;\n    font-style: italic;\n  }\n\n  .badge-success {\n    background-color: var(--cui-success) !important;\n    color: #fff;\n  }\n\n  .badge-danger {\n    background-color: var(--cui-danger) !important;\n    color: #fff;\n  }\n\n  .table.table-hover > tbody > tr:hover {\n    border-color: var(--table-border-color) !important;\n    color: var(--table-text-color) !important;\n    \n    td {\n      color: var(--table-text-color) !important;\n    }\n    \n    th {\n      color: var(--table-text-color) !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
